import React from 'react';
import { Link } from 'react-router-dom';
import { bookingOptionsForDestination } from '../../data/bookingExperienceData';
import '../../styles/booking-experience.scss';

function DestinationBookingSection({ destination }) {
	const options = bookingOptionsForDestination(destination);
	if (!options.length) return null;

	return (
		<section className="destination-booking" aria-labelledby="destination-booking-title">
			<h2 id="destination-booking-title" className="destination-booking__title">
				Ready to visit {destination.name}?
			</h2>
			<p className="destination-booking__lead">
				Book with VisitAllNepal — secure payment, local support, and the right operator assigned for your trip.
			</p>
			<div className="destination-booking__grid">
				{options.map((opt) => (
					<Link key={opt.id} to={opt.route} className="destination-booking__card">
						<h3 className="destination-booking__card-title">{opt.title}</h3>
						<p className="destination-booking__card-desc">{opt.desc}</p>
						<span className="destination-booking__card-cta">{opt.cta} →</span>
					</Link>
				))}
			</div>
		</section>
	);
}

export default DestinationBookingSection;
